// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/RightCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var RightCircleOutlined = function RightCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleOutlinedSvg
  }));
};

RightCircleOutlined.displayName = 'RightCircleOutlined';
export default React.forwardRef(RightCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/RightCircleOutlined.js
// module id = 1709
// module chunks = 0